import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";

import { forwardRef, useImperativeHandle } from 'react';

import { AuthContext } from "../context/Auth";
import { auth, signOut } from "../firebase";
import { UserContext } from "../context/User";
import Api from "../Api";
import { useUserStatus } from "../context/UserStatusContext";
import { isSubscriptionAccessBlocked } from "../utils/subscriptionStatus";
// ({ current })
const SideMenu = forwardRef(({ current }, ref)  => {
  const api = Api();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const { userType } = useContext(UserContext);

  const { userStatus, updateUserStatus } = useUserStatus();
  const [answerSets, setAnswerSets] = useState([]);
  const [show, setShow] = useState(false);
  const [userData, setUserData] = useState({
    subscriptionStatus : "Inactive"
  });

  const [navbar, setNavbar] = useState(false);



  // useEffect(async () => {
  //   currentUser &&
  //     (await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/users/${currentUser.uid}/answerSets`
  //     )
  //       .then((res) => res.json())
  //       .then((data) => {
  //         setAnswerSets(data);
  //       }));
  // }, []);

  // useEffect(async () => {
  //   currentUser &&
  //     (await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/users/${currentUser.uid}`
  //     )
  //       .then((res) => res.json())
  //       .then((user) => {
  //         // if (user.subscriptionType === "Pro") {
  //         //   setShow(false);
  //         // }
  //         console.log(user, "user")
  //         if (user.subscriptionStatus === "Inactive") {
  //           setShow(true);
  //         }
  //       }));
  // }, []);


  useEffect(() => {
    if (!currentUser?.uid) {
      return;
    }

    getuser();
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/users/${currentUser.uid}/answerSets`
        );

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setAnswerSets(data.answerSets || []);
      } catch (error) {
        console.error('Error fetching data:', error.message);
        setAnswerSets([]);
      }
    };

    fetchData();
  }, [currentUser ]);

    const getuser = async () => {


    if (!currentUser?.uid) {
      return;
    }

    try {
      const user = await api.getApi(`users/${currentUser.uid}`);

      setUserData(user);

      console.log("user in side menu",user);
    } catch (error) {
      console.error("Error loading user in side menu:", error);
      setUserData({
        subscriptionStatus: "Inactive",
      });
    }

  };

  useImperativeHandle(ref, () => ({
    childFunction() {
      getuser();
        },
  }));



  const upgradeSubscription = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/subscriptions`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: currentUser.uid,
        }),
      }
    );

    const { url } = await response.json();
    window.location.href = url;
  };

  // Function 1 - Log out
  const handleSignOut = () => {
    signOut(auth).then(() => navigate("/login"));
  };

  const navigation = ()=>{
    return  <nav className="md:mt-5 flex-1 px-2 md:bg-gray-50 ">
    <div className="w-full flex justify-start mt-3 mb-2 px-2">
      <span className="font-sans font-medium text-gray-400 text-xs tracking-wide">
        Workspace
      </span>
    </div>
    {userType == 'admin' ?
    (
      <>
        <a
          onClick={() => navigate("/admin")}
          className={`${
            current === "admin" && "bg-gray-200"
          } group flex items-center px-4 py-2 text-sm font-medium rounded-md cursor-pointer relative`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
          <div className="flex justify-between items-center">
            <span className="font-sans font-medium text-gray-900 text-xs">
              Access Control
            </span>

          </div>
        </a>

        <a
          onClick={() => navigate("/subscriptionmanage")}
          className={`${
            current === "subscription" && "bg-gray-200"
          } group flex items-center px-4 py-2 text-sm font-medium rounded-md cursor-pointer relative`}
        >
         <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 3a3 3 0 013 3v12a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3h6zm-2 0v4m0 6h0m0-6h6"
            />
          </svg>
          <div className="flex justify-between items-center">
            <span className="font-sans font-medium text-gray-900 text-xs">
             Subscription Management
            </span>

          </div>
        </a>


        <a
          onClick={() => navigate("/mailtemplate")}
          className={`${
            current === "template" && "bg-gray-200"
          } group flex items-center px-4 py-2 text-sm font-medium rounded-md cursor-pointer relative`}
        >
         <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-3 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M22 12h-20M2 6l10 7 10-7M2 6l10 7 10-7"
                />
              </svg>
          <div className="flex justify-between items-center">
            <span className="font-sans font-medium text-gray-900 text-xs">
             Email Template Management
            </span>

          </div>
        </a>


      </>
    ) :
    (
      <>


      {/* {userData.subscriptionStatus != "Inactive" && ( */}
      {!isSubscriptionAccessBlocked(userStatus) && (
        <>
    <a
          onClick={() => {navigate("/"); console.log("user.subscriptionType" , userData); }}
          className={`${
            current === "home" && "bg-gray-200"
          } group flex items-center px-4 py-2 text-sm font-medium rounded-md cursor-pointer relative`}
        >
          {answerSets.length > 0 && (
            <div className="absolute right-4 w-6 h-6 rounded-full flex justify-center items-center bg-gray-200 font-sans font-medium text-gray-900 text-xs">
              {answerSets.length}
            </div>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-3 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
          <div className="flex justify-between items-center">
            <span className="font-sans font-medium text-gray-900 text-xs">
              Home
            </span>
          </div>
        </a>
        <a
          onClick={() => navigate("/interviews")}
          className={`${
            current === "interviews" && "bg-gray-200"
          } group flex items-center px-4 py-2 text-sm font-medium rounded-md cursor-pointer`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 mr-3 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
          <span className="font-sans font-medium text-gray-900 text-xs">
            Interviews
          </span>
        </a>
        <a
          onClick={() => navigate("/archived")}
          className={`${
            current === "archived" && "bg-gray-200"
          } group flex items-center px-4 py-2 text-sm font-medium rounded-md cursor-pointer relative`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-4 h-4 mr-3 fill-current text-blue-600"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M3 10H2V4.003C2 3.449 2.455 3 2.992 3h18.016A.99.99 0 0 1 22 4.003V10h-1v10.001a.996.996 0 0 1-.993.999H3.993A.996.996 0 0 1 3 20.001V10zm16 0H5v9h14v-9zM4 5v3h16V5H4zm5 7h6v2H9v-2z" />
          </svg>
          <span className="font-sans font-medium text-gray-900 text-xs">
            Archived
          </span>
        </a>
        </>
      )}


        <a
          href="mailto:team@usehaste.io"
          className="mt-4 px-4 cursor-pointer flex justify-between items-center group"
        >
          <div className="py-2 group flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-3 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            <span className="font-sans font-medium text-gray-900 text-xs">
              Support
            </span>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-gray-400 transform -rotate-45 group-hover:text-gray-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </a>
        {/* {userData.subscriptionStatus != "Inactive" && ( */}
          {!isSubscriptionAccessBlocked(userStatus) && (

        <a
          href="https://usehaste.io/contact"
          target="_blank"
          rel="noreferrer"
          className="px-4 cursor-pointer flex justify-between items-center group"
        >
          <div className="py-2 group flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-3 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
              />
            </svg>
            <span className="font-sans font-medium text-gray-900 text-xs">
              Give us feedback
            </span>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-gray-400 transform -rotate-45 group-hover:text-gray-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </a>
        )}

    </>
    )}

    {show && userType != 'admin' && (
      <div>
        <div className="w-full h-px bg-gray-200 mt-6 mb-6"></div>
        <div className="w-full px-4 flex flex-col">
          <span className="font-sans font-semibold text-xs text-blue-600">
            Ready to upgrade?
          </span>
          <span className="mt-1 font-sans font-medium text-xs text-gray-500 leading-5">
            If you activate to Pro you won't have any limits on the
            amount of interviews you can create.
          </span>
          <button
            onClick={() => upgradeSubscription()}
            className="hover:bg-blue-700 mt-4 w-full flex justify-center items-center h-8 rounded-md bg-blue-600 font-sans font-semibold text-xs text-white"
          >
            Activate PRO Plan
          </button>
        </div>
      </div>
    )}
  </nav>
  }

  const bottonNav = ()=>{
    return <div className="flex-shrink-0 flex border-t border-gray-200 p-2">
            <button
              onClick={() => navigate("/settings")}
              className="w-full flex justify-center items-center hover:bg-gray-200 rounded-full py-2 space-x-2 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-gray-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span className="font-sans font-medium text-gray-900 text-sm">
                Settings
              </span>
            </button>
          </div>
  }

  return (
    <div>
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
        <div className="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-gray-50">
          <div className="flex-1 flex flex-col md:pt-5 pb-4 overflow-y-auto md:bg-gray-50">
            <div
              onClick={() => navigate("/settings")}
              className="flex items-center flex-shrink-0 md:px-6 px-2 cursor-pointer"
            >
              <svg
                className="h-6"
                viewBox="0 0 131 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M42.34 29V3.08H46.948V13.88C47.548 12.896 48.352 12.128 49.36 11.576C50.392 11 51.568 10.712 52.888 10.712C55.096 10.712 56.8 11.408 58 12.8C59.224 14.192 59.836 16.232 59.836 18.92V29H55.264V19.352C55.264 17.816 54.952 16.64 54.328 15.824C53.728 15.008 52.768 14.6 51.448 14.6C50.152 14.6 49.072 15.056 48.208 15.968C47.368 16.88 46.948 18.152 46.948 19.784V29H42.34ZM68.5983 29.432C67.0623 29.432 65.8023 29.192 64.8183 28.712C63.8343 28.208 63.1023 27.548 62.6223 26.732C62.1423 25.916 61.9023 25.016 61.9023 24.032C61.9023 22.376 62.5503 21.032 63.8463 20C65.1423 18.968 67.0863 18.452 69.6783 18.452H74.2143V18.02C74.2143 16.796 73.8663 15.896 73.1703 15.32C72.4743 14.744 71.6103 14.456 70.5783 14.456C69.6423 14.456 68.8263 14.684 68.1303 15.14C67.4343 15.572 67.0023 16.22 66.8343 17.084H62.3343C62.4543 15.788 62.8863 14.66 63.6303 13.7C64.3983 12.74 65.3823 12.008 66.5823 11.504C67.7823 10.976 69.1263 10.712 70.6143 10.712C73.1583 10.712 75.1623 11.348 76.6263 12.62C78.0903 13.892 78.8223 15.692 78.8223 18.02V29H74.8983L74.4663 26.12C73.9383 27.08 73.1943 27.872 72.2343 28.496C71.2983 29.12 70.0863 29.432 68.5983 29.432ZM69.6423 25.832C70.9623 25.832 71.9823 25.4 72.7023 24.536C73.4463 23.672 73.9143 22.604 74.1063 21.332H70.1823C68.9583 21.332 68.0823 21.56 67.5543 22.016C67.0263 22.448 66.7623 22.988 66.7623 23.636C66.7623 24.332 67.0263 24.872 67.5543 25.256C68.0823 25.64 68.7783 25.832 69.6423 25.832ZM88.7997 29.432C87.2157 29.432 85.8237 29.18 84.6237 28.676C83.4237 28.148 82.4637 27.428 81.7437 26.516C81.0237 25.604 80.5917 24.548 80.4477 23.348H85.0917C85.2357 24.044 85.6197 24.644 86.2437 25.148C86.8917 25.628 87.7197 25.868 88.7277 25.868C89.7357 25.868 90.4677 25.664 90.9237 25.256C91.4037 24.848 91.6437 24.38 91.6437 23.852C91.6437 23.084 91.3077 22.568 90.6357 22.304C89.9637 22.016 89.0277 21.74 87.8277 21.476C87.0597 21.308 86.2797 21.104 85.4877 20.864C84.6957 20.624 83.9637 20.324 83.2917 19.964C82.6437 19.58 82.1157 19.1 81.7077 18.524C81.2997 17.924 81.0957 17.192 81.0957 16.328C81.0957 14.744 81.7197 13.412 82.9677 12.332C84.2397 11.252 86.0157 10.712 88.2957 10.712C90.4077 10.712 92.0877 11.204 93.3357 12.188C94.6077 13.172 95.3637 14.528 95.6037 16.256H91.2477C90.9837 14.936 89.9877 14.276 88.2597 14.276C87.3957 14.276 86.7237 14.444 86.2437 14.78C85.7877 15.116 85.5597 15.536 85.5597 16.04C85.5597 16.568 85.9077 16.988 86.6037 17.3C87.2997 17.612 88.2237 17.9 89.3757 18.164C90.6237 18.452 91.7637 18.776 92.7957 19.136C93.8517 19.472 94.6917 19.988 95.3157 20.684C95.9397 21.356 96.2517 22.328 96.2517 23.6C96.2757 24.704 95.9877 25.7 95.3877 26.588C94.7877 27.476 93.9237 28.172 92.7957 28.676C91.6677 29.18 90.3357 29.432 88.7997 29.432ZM105.927 29C104.055 29 102.555 28.544 101.427 27.632C100.299 26.72 99.7352 25.1 99.7352 22.772V14.996H96.6752V11.144H99.7352L100.275 6.356H104.343V11.144H109.167V14.996H104.343V22.808C104.343 23.672 104.523 24.272 104.883 24.608C105.267 24.92 105.915 25.076 106.827 25.076H109.059V29H105.927ZM119.543 29.432C117.743 29.432 116.147 29.048 114.755 28.28C113.363 27.512 112.271 26.432 111.479 25.04C110.687 23.648 110.291 22.04 110.291 20.216C110.291 18.368 110.675 16.724 111.443 15.284C112.235 13.844 113.315 12.728 114.683 11.936C116.075 11.12 117.707 10.712 119.579 10.712C121.331 10.712 122.879 11.096 124.223 11.864C125.567 12.632 126.611 13.688 127.355 15.032C128.123 16.352 128.507 17.828 128.507 19.46C128.507 19.724 128.495 20 128.471 20.288C128.471 20.576 128.459 20.876 128.435 21.188H114.863C114.959 22.58 115.439 23.672 116.303 24.464C117.191 25.256 118.259 25.652 119.507 25.652C120.443 25.652 121.223 25.448 121.847 25.04C122.495 24.608 122.975 24.056 123.287 23.384H127.967C127.631 24.512 127.067 25.544 126.275 26.48C125.507 27.392 124.547 28.112 123.395 28.64C122.267 29.168 120.983 29.432 119.543 29.432ZM119.579 14.456C118.451 14.456 117.455 14.78 116.591 15.428C115.727 16.052 115.175 17.012 114.935 18.308H123.827C123.755 17.132 123.323 16.196 122.531 15.5C121.739 14.804 120.755 14.456 119.579 14.456Z"
                  fill="black"
                />
                <rect
                  y="7.41382"
                  width="19.6571"
                  height="4.91429"
                  fill="#145AFF"
                />
                <rect
                  x="18.0129"
                  y="0.0424805"
                  width="19.6581"
                  height="4.91429"
                  transform="rotate(66.5 18.0129 0.0424805)"
                  fill="#145AFF"
                />
                <rect
                  width="19.6606"
                  height="4.91429"
                  transform="matrix(0.265294 -0.964168 -0.964168 -0.265294 7.59549 29.4124)"
                  fill="#145AFF"
                />
                <rect
                  width="19.6582"
                  height="4.91429"
                  transform="matrix(0.758404 0.651785 0.651785 -0.758404 6.14285 19.0227)"
                  fill="#145AFF"
                />
                <rect
                  width="19.6614"
                  height="4.91429"
                  transform="matrix(-0.788347 0.615231 0.615231 0.788347 29.0143 10.4722)"
                  fill="#145AFF"
                />
                <rect
                  x="11.0571"
                  y="11.0996"
                  width="9.82857"
                  height="9.82857"
                  fill="#145AFF"
                />
                <circle cx="15.3571" cy="15.3996" r="3.07143" fill="white" />
              </svg>
            </div>
            {navigation()}
          </div>
          {bottonNav()}
        </div>
      </div>

      <nav className="fixed shadow-md z-10 md:hidden w-full bg-white">
        <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
          <div>
              <div className="flex items-center justify-between py-3 md:py-5 md:block">
                  {/* <a href="javascript:void(0)"> */}
                  <a>
                    <div
                      onClick={() => navigate("/")}
                      className="flex items-center flex-shrink-0 px-6 cursor-pointer"
                    >
                      <svg
                        className="h-6"
                        viewBox="0 0 131 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M42.34 29V3.08H46.948V13.88C47.548 12.896 48.352 12.128 49.36 11.576C50.392 11 51.568 10.712 52.888 10.712C55.096 10.712 56.8 11.408 58 12.8C59.224 14.192 59.836 16.232 59.836 18.92V29H55.264V19.352C55.264 17.816 54.952 16.64 54.328 15.824C53.728 15.008 52.768 14.6 51.448 14.6C50.152 14.6 49.072 15.056 48.208 15.968C47.368 16.88 46.948 18.152 46.948 19.784V29H42.34ZM68.5983 29.432C67.0623 29.432 65.8023 29.192 64.8183 28.712C63.8343 28.208 63.1023 27.548 62.6223 26.732C62.1423 25.916 61.9023 25.016 61.9023 24.032C61.9023 22.376 62.5503 21.032 63.8463 20C65.1423 18.968 67.0863 18.452 69.6783 18.452H74.2143V18.02C74.2143 16.796 73.8663 15.896 73.1703 15.32C72.4743 14.744 71.6103 14.456 70.5783 14.456C69.6423 14.456 68.8263 14.684 68.1303 15.14C67.4343 15.572 67.0023 16.22 66.8343 17.084H62.3343C62.4543 15.788 62.8863 14.66 63.6303 13.7C64.3983 12.74 65.3823 12.008 66.5823 11.504C67.7823 10.976 69.1263 10.712 70.6143 10.712C73.1583 10.712 75.1623 11.348 76.6263 12.62C78.0903 13.892 78.8223 15.692 78.8223 18.02V29H74.8983L74.4663 26.12C73.9383 27.08 73.1943 27.872 72.2343 28.496C71.2983 29.12 70.0863 29.432 68.5983 29.432ZM69.6423 25.832C70.9623 25.832 71.9823 25.4 72.7023 24.536C73.4463 23.672 73.9143 22.604 74.1063 21.332H70.1823C68.9583 21.332 68.0823 21.56 67.5543 22.016C67.0263 22.448 66.7623 22.988 66.7623 23.636C66.7623 24.332 67.0263 24.872 67.5543 25.256C68.0823 25.64 68.7783 25.832 69.6423 25.832ZM88.7997 29.432C87.2157 29.432 85.8237 29.18 84.6237 28.676C83.4237 28.148 82.4637 27.428 81.7437 26.516C81.0237 25.604 80.5917 24.548 80.4477 23.348H85.0917C85.2357 24.044 85.6197 24.644 86.2437 25.148C86.8917 25.628 87.7197 25.868 88.7277 25.868C89.7357 25.868 90.4677 25.664 90.9237 25.256C91.4037 24.848 91.6437 24.38 91.6437 23.852C91.6437 23.084 91.3077 22.568 90.6357 22.304C89.9637 22.016 89.0277 21.74 87.8277 21.476C87.0597 21.308 86.2797 21.104 85.4877 20.864C84.6957 20.624 83.9637 20.324 83.2917 19.964C82.6437 19.58 82.1157 19.1 81.7077 18.524C81.2997 17.924 81.0957 17.192 81.0957 16.328C81.0957 14.744 81.7197 13.412 82.9677 12.332C84.2397 11.252 86.0157 10.712 88.2957 10.712C90.4077 10.712 92.0877 11.204 93.3357 12.188C94.6077 13.172 95.3637 14.528 95.6037 16.256H91.2477C90.9837 14.936 89.9877 14.276 88.2597 14.276C87.3957 14.276 86.7237 14.444 86.2437 14.78C85.7877 15.116 85.5597 15.536 85.5597 16.04C85.5597 16.568 85.9077 16.988 86.6037 17.3C87.2997 17.612 88.2237 17.9 89.3757 18.164C90.6237 18.452 91.7637 18.776 92.7957 19.136C93.8517 19.472 94.6917 19.988 95.3157 20.684C95.9397 21.356 96.2517 22.328 96.2517 23.6C96.2757 24.704 95.9877 25.7 95.3877 26.588C94.7877 27.476 93.9237 28.172 92.7957 28.676C91.6677 29.18 90.3357 29.432 88.7997 29.432ZM105.927 29C104.055 29 102.555 28.544 101.427 27.632C100.299 26.72 99.7352 25.1 99.7352 22.772V14.996H96.6752V11.144H99.7352L100.275 6.356H104.343V11.144H109.167V14.996H104.343V22.808C104.343 23.672 104.523 24.272 104.883 24.608C105.267 24.92 105.915 25.076 106.827 25.076H109.059V29H105.927ZM119.543 29.432C117.743 29.432 116.147 29.048 114.755 28.28C113.363 27.512 112.271 26.432 111.479 25.04C110.687 23.648 110.291 22.04 110.291 20.216C110.291 18.368 110.675 16.724 111.443 15.284C112.235 13.844 113.315 12.728 114.683 11.936C116.075 11.12 117.707 10.712 119.579 10.712C121.331 10.712 122.879 11.096 124.223 11.864C125.567 12.632 126.611 13.688 127.355 15.032C128.123 16.352 128.507 17.828 128.507 19.46C128.507 19.724 128.495 20 128.471 20.288C128.471 20.576 128.459 20.876 128.435 21.188H114.863C114.959 22.58 115.439 23.672 116.303 24.464C117.191 25.256 118.259 25.652 119.507 25.652C120.443 25.652 121.223 25.448 121.847 25.04C122.495 24.608 122.975 24.056 123.287 23.384H127.967C127.631 24.512 127.067 25.544 126.275 26.48C125.507 27.392 124.547 28.112 123.395 28.64C122.267 29.168 120.983 29.432 119.543 29.432ZM119.579 14.456C118.451 14.456 117.455 14.78 116.591 15.428C115.727 16.052 115.175 17.012 114.935 18.308H123.827C123.755 17.132 123.323 16.196 122.531 15.5C121.739 14.804 120.755 14.456 119.579 14.456Z"
                          fill="black"
                        />
                        <rect
                          y="7.41382"
                          width="19.6571"
                          height="4.91429"
                          fill="#145AFF"
                        />
                        <rect
                          x="18.0129"
                          y="0.0424805"
                          width="19.6581"
                          height="4.91429"
                          transform="rotate(66.5 18.0129 0.0424805)"
                          fill="#145AFF"
                        />
                        <rect
                          width="19.6606"
                          height="4.91429"
                          transform="matrix(0.265294 -0.964168 -0.964168 -0.265294 7.59549 29.4124)"
                          fill="#145AFF"
                        />
                        <rect
                          width="19.6582"
                          height="4.91429"
                          transform="matrix(0.758404 0.651785 0.651785 -0.758404 6.14285 19.0227)"
                          fill="#145AFF"
                        />
                        <rect
                          width="19.6614"
                          height="4.91429"
                          transform="matrix(-0.788347 0.615231 0.615231 0.788347 29.0143 10.4722)"
                          fill="#145AFF"
                        />
                        <rect
                          x="11.0571"
                          y="11.0996"
                          width="9.82857"
                          height="9.82857"
                          fill="#145AFF"
                        />
                        <circle cx="15.3571" cy="15.3996" r="3.07143" fill="white" />
                      </svg>
                    </div>
                  </a>
                  <div className="md:hidden">
                      <button
                          className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                          onClick={() => setNavbar(!navbar)}
                      >
                          {navbar ? (
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-6 h-6 text-black"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                              >
                                  <path
                                      fillRule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clipRule="evenodd"
                                  />
                              </svg>
                          ) : (
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-6 h-6 text-black"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  strokeWidth={2}
                              >
                                  <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M4 6h16M4 12h16M4 18h16"
                                  />
                              </svg>
                          )}
                      </button>
                  </div>
              </div>
          </div>
          <div>
            <div className={`flex-1 justify-self-center pb-3 md:block md:pb-0 md:mt-0 ${navbar ? "block" : "hidden"} transition ease-in-out delay-150 `}>
              <div className="flex-1 flex flex-col pb-4 overflow-y-auto bg-gray-0">
              {navigation()}
              </div>
              {bottonNav()}
            </div>
          </div>
        </div>
      </nav>



  </div>
  );
});

export default SideMenu;
